import { memo } from 'react';
import cn from 'classnames';
import { Grid } from 'ht-styleguide';
import { Sku } from 'types/sku.types';
import styles from './skudetails.module.scss';

const ServiceDetails = ({ sku }: { sku: Sku }) => (
  <div className={styles.container}>
    <Grid.FullWidth>
      <h4 className="h4">Details</h4>
      <div className={cn('p1', styles.description)}>{sku.description}</div>
    </Grid.FullWidth>
  </div>
);

export default memo(ServiceDetails);
